/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface MaintenanceModeExceptionDetails
 */
export interface MaintenanceModeExceptionDetails {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceModeExceptionDetails
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeExceptionDetails
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeExceptionDetails
     */
    activationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceModeExceptionDetails
     */
    $type?: MaintenanceModeExceptionDetailsTypeEnum;
}


/**
 * @export
 */
export const MaintenanceModeExceptionDetailsTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonMaintenanceModeExceptionDetailsPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.MaintenanceModeExceptionDetails, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type MaintenanceModeExceptionDetailsTypeEnum = typeof MaintenanceModeExceptionDetailsTypeEnum[keyof typeof MaintenanceModeExceptionDetailsTypeEnum];


/**
 * Check if a given object implements the MaintenanceModeExceptionDetails interface.
 */
export function instanceOfMaintenanceModeExceptionDetails(value?: unknown): value is MaintenanceModeExceptionDetails {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MaintenanceModeExceptionDetailsTypeEnum)[0];
}

export function MaintenanceModeExceptionDetailsFromJSON(json: any): MaintenanceModeExceptionDetails {
    return MaintenanceModeExceptionDetailsFromJSONTyped(json, false);
}

export function MaintenanceModeExceptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceModeExceptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'activationDate': !exists(json, 'activationDate') ? undefined : json['activationDate'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function MaintenanceModeExceptionDetailsToJSON(value?: MaintenanceModeExceptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'userId': value.userId,
        'userName': value.userName,
        'activationDate': value.activationDate,
        '$type': value.$type,
    });
}

